import { useEffect, useMemo, useState } from "react";
import { useData } from "../../../context/DataProvider";
import "./index.scss";
import { LineChart } from "@mui/x-charts";

const StackedChart = (props: {scenario: string, period: string}) => {
    const {stackedEnergy} = useData()!;
    const [currentScenario, setCurrentScenario] = useState<any[]>();
    useEffect(()=>{
        if(stackedEnergy && props.scenario){
        const filteredScenario = stackedEnergy?.filter((item)=>{
            return item.Scenario === props.scenario
        })
        setCurrentScenario(()=>filteredScenario)
    }
    }, [stackedEnergy, props.scenario])
    const numberCheck = (num: any) => {
        if(!isNaN(+num))
            return +num;
        else
            return(+(num.replace(",","")));
    }
    const storageNegative = useMemo(()=>{
        if(!currentScenario){
            return []
        }
        return currentScenario?.filter((item)=>{
            return item.Type === "Storage_Negative"
        })?.sort((a, b)=>a.Period - b.Period)
        ?.map((filteredItem)=>numberCheck(filteredItem.Value))
        ?.slice(0, +props.period+1)
    }, [currentScenario, props.period])
    const natStorageNegative = useMemo(()=>{
        if(!currentScenario){
            return []
        }
        return currentScenario?.filter((item)=>{
            return item.Type === "Natrium_Storage_Negative"
        })?.sort((a, b)=>a.Period - b.Period)
        ?.map((filteredItem)=>numberCheck(filteredItem.Value))
        ?.slice(0, +props.period+1)
    }, [currentScenario, props.period])
    const natrium = useMemo(()=>{
        if(!currentScenario){
            return []
        }
        return currentScenario?.filter((item)=>{
            return item.Type === "Natrium_Reactor"
        })?.sort((a, b)=>a.Period - b.Period)
        ?.map((filteredItem) => numberCheck(filteredItem.Value))
        ?.slice(0, +props.period+1)
    }, [currentScenario, props.period])
    const hydro = useMemo(()=>{
        if(!currentScenario){
            return []
        }
        return currentScenario?.filter((item)=>{
            return item.Type === "Hydro"
        })?.sort((a, b)=>a.Period - b.Period)
        ?.map((filteredItem) => numberCheck(filteredItem.Value))
        ?.slice(0, +props.period+1)
    }, [currentScenario, props.period])
    const solar = useMemo(()=>{
        if(!currentScenario){
            return []
        }
        return currentScenario?.filter((item)=>{
            return item.Type === "Solar"
        })?.sort((a, b)=>a.Period - b.Period)
        ?.map((filteredItem) => numberCheck(filteredItem.Value))
        ?.slice(0, +props.period+1)
    }, [currentScenario, props.period])
    const wind = useMemo(()=>{
        if(!currentScenario){
            return []
        }
        return currentScenario?.filter((item)=>{
            return item.Type === "Wind"
        })?.sort((a, b)=>a.Period - b.Period)
        ?.map((filteredItem) => numberCheck(filteredItem.Value))
        ?.slice(0, +props.period+1)
    }, [currentScenario, props.period])
    const natStorage = useMemo(()=>{
        if(!currentScenario){
            return []
        }
        return currentScenario?.filter((item)=>{
            return item.Type === "Natrium_Storage_Positive"
        })?.sort((a, b)=>a.Period - b.Period)
        ?.map((filteredItem)=>{
                return numberCheck(filteredItem.Value)
        })
        ?.slice(0, +props.period+1)
    }, [currentScenario, props.period])
    const storage = useMemo(()=>{
        if(!currentScenario){
            return []
        }
        return currentScenario?.filter((item)=>{
            return item.Type === "Storage_Positive"
        })?.sort((a, b)=>a.Period - b.Period)
        ?.map((filteredItem)=>{
                return numberCheck(filteredItem.Value)
        })
        ?.slice(0, +props.period+1)
    }, [currentScenario, props.period])

    const colorAssign = (color: string) => {
        switch(color){
            case "Hydro":
                return "#B7D3E4";
            case "Solar":
                return "#EEBF66";
            case "Wind":
                return "#007AE4";
            case "Storage":
                return "#C34B46";
            case "Nat-Storage":
                return "#88B04F";
            case "Nat-Gen":
                return "#203C5B";
        }
    }
    const StackedLegend = () => {
        return(
        <div className={`stacked-legendR`}>
            <div className="legend-member">
                <div className="legend-circle" style={{backgroundColor: colorAssign("Hydro")}}/>
                <span>Hydro</span>
            </div>
            <div className="legend-member">
                <div className="legend-circle" style={{backgroundColor: colorAssign("Solar")}}/>
                <span>Solar</span>
            </div>
            <div className="legend-member">
                <div className="legend-circle" style={{backgroundColor: colorAssign("Wind")}}/>
                <span>Wind</span>
            </div>
            <div className="legend-member">
                <div className="legend-circle" style={{backgroundColor: colorAssign("Storage")}}/>
                <span>Storage</span>
            </div>
            <div className="legend-member">
                <div className="legend-circle" style={{backgroundColor: colorAssign("Nat-Storage")}}/>
                <span>Natrium-Storage</span>
            </div>
            <div className="legend-member">
                <div className="legend-circle" style={{backgroundColor: colorAssign("Nat-Gen")}}/>
                <span>Natrium-Reactor</span>
            </div>
        </div>
        )
    }
    const xLabels = [
        "12",
        "24",
        "36",
        "48",
        "60",
        "72"
    ]
    const xLabels2 = useMemo(()=>{
        return Array.from({ length: +props.period+2 }, (_, index) => index);
    }, [props.period])
    return(<>
        {
        <div className={`stacked-containerR`}>
        <LineChart 
        loading={!stackedEnergy}
        margin={{left: 50}}
        series={[
            { stackOffset:"diverging", data: [0, ...storageNegative],  area: true, stack: 'total', showMark: false, color: colorAssign("Storage") },
            { stackOffset:"diverging", data: [0, ...natStorageNegative],  area: true, stack: 'total', showMark: false, color: colorAssign("Nat-Storage") },
            { stackOffset:"diverging", data: [0, ...natrium], area: true, stack: 'total', showMark: false, color: colorAssign("Nat-Gen") },
            { stackOffset:"diverging", data: [0, ...hydro],  area: true, stack: 'total', showMark: false, color: colorAssign("Hydro") },
            { stackOffset:"diverging", data: [0, ...solar],  area: true, stack: 'total', showMark: false, color: colorAssign("Solar") },
            { stackOffset:"diverging", data: [0, ...wind],  area: true, stack: 'total', showMark: false, color: colorAssign("Wind") },
            { stackOffset:"diverging", data: [0, ...natStorage],  area: true, stack: 'total', showMark: false, color: colorAssign("Nat-Storage") },
            { stackOffset:"diverging", data: [0, ...storage],  area: true, stack: 'total', showMark: false, color: colorAssign("Storage") },
        ]}
        yAxis={[{tickLabelStyle: {fontSize: 10}}]}
        xAxis={[{stroke: "#FFF", fill: "#FFF", data: xLabels2, max: xLabels2.length-2, tickMinStep: 1, tickLabelStyle: {fontSize: 10}}]}
        grid={{vertical: true, horizontal: true}}
        /></div>}
        <StackedLegend />
    </>
    )
}

export default StackedChart;